import React, { useState, useRef, useEffect } from "react";
import InquiryService from "../../services/inquiryService";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UiH4 } from "../../components/text/UiTitle";
import { icAsset } from "../../components/image/image-src";
interface Category {
  label: string;
  value: string;
  select: boolean;
}
const PostInquiry: React.FC = () => {
  const { t } = useTranslation();
  const [title, setTitle] = useState("");
  const [titleI, setTitleI] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const maxLength = 150;
  const maxLengthI = 600;
  const [imageSrcs, setImageSrcs] = useState<string[]>([]);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [isPopupSelectVisible, setPopupSelectVisible] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [selectedCategoryTitle, setSelectedCategoryTitle] =
    useState<Category>();
  const categoryValues = [
    "PASS",
    "TICKET",
    "TOUR",
    "MUSICAL",
    "SIM",
    "CANCEL",
    "UPGRADE",
  ];
  const getCategoryLabel = (key: string) => {
    switch (key) {
      case "PASS":
        return t("Pass");
      case "TICKET":
        return t("Ticket");
      case "TOUR":
        return t("Tour");
      case "MUSICAL":
        return t("Musical");
      case "SIM":
        return t("E-sim");
      case "CANCEL":
        return t("Cancel/ refund policy");
      case "UPGRADE":
        return t("Upgrade process");
      default:
        return key;
    }
  };
  const [categories, setCategories] = useState<Category[]>(
    categoryValues.map((val) => ({
      value: val,
      label: getCategoryLabel(val),
      select: false,
    })),
  );

  // Update category labels when language (t) changes
  useEffect(() => {
    setCategories((prevCategories) =>
      prevCategories.map((cat) => ({
        ...cat,
        label: getCategoryLabel(cat.value),
      })),
    );
  }, [t]);

  // const [categories, setCategories] = useState<Category[]>([
  //   { label: t("Pass"), value: "PASS", select: false },
  //   { label: t("Ticket"), value: "TICKET", select: false },
  //   { label: t("Tour"), value: "TOUR", select: false },
  //   { label: t("Musical"), value: "MUSICAL", select: false },
  //   { label: t("E-sim"), value: "SIM", select: false },
  //   { label: t("Cancel/ refund policy"), value: "CANCEL", select: false },
  //   { label: t("Upgrade process"), value: "UPGRADE", select: false },
  // ]);
  const navigate = useNavigate();

  const handleImageRemove = (index: number) => {
    setImageSrcs((prevSrcs) => prevSrcs.filter((_, i) => i !== index));
  };

  const closePopup = () => {
    setPopupVisible(false);
    navigate("/my-inquiry");
  };

  const closePopupSelect = () => {
    setTitle(titleI);
    setPopupSelectVisible(false);
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      const newImageSrcs: string[] = [];
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();
        reader.onloadend = () => {
          newImageSrcs.push(reader.result as string);
          if (newImageSrcs.length === files.length) {
            setImageSrcs((prevSrcs) => [...prevSrcs, ...newImageSrcs]);
          }
        };
        reader.readAsDataURL(file);
      }
    }
  };

  const handleDivClick = () => {
    fileInputRef.current?.click();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(e.target.value);
  };

  const handleChangeInquiry = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTitleI(e.target.value);
  };

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPhone(e.target.value);
  };

  const openPopupSelect = () => {
    setPopupSelectVisible(true);
  };

  const toggleSelect = (index: number) => {
    setCategories((prevCategories) =>
      prevCategories.map((category, i) => ({
        ...category,
        select: i === index,
      })),
    );
    setSelectedCategoryTitle(categories[index]);
  };

  const validateSubmit = () => {
    return (
      title &&
      titleI &&
      name &&
      email &&
      phone &&
      categories.some((cat) => cat.select) &&
      !isLoading
    );
  };
  const handleSubmit = async () => {
    if (!validateSubmit()) {
      return;
    }
    const selectedCategory = categories.find((cat) => cat.select)?.value;
    try {
      setLoading(true);
      await InquiryService.creareInquiry({
        title,
        titleI,
        selectedCategory,
        imageSrcs,
        name,
        email,
        phone,
      });
      setPopupVisible(true);
    } catch (error) {
      console.log("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto flex w-full flex-col items-start px-0 sm:max-w-[84.13rem] sm:pl-[15.00rem] sm:pr-[3.50rem]">
      <div className="bg-white-a700 flex w-full flex-col gap-[1.75rem] rounded-[20px] px-4 py-[2.50rem] sm:w-[76%] sm:px-[1.88rem]">
        <button onClick={openPopupSelect}>
          <div className="flex items-center justify-between">
            <UiH4 text={selectedCategoryTitle?.label || t("Select Category")} />
            <img
              className="h-[1.00rem]"
              src={icAsset("../../assets/icons/swiper_next_arrow.svg")}
              alt="Arrow Right Icon"
              loading="lazy"
            />
          </div>
        </button>

        <div className="h-[0.13rem] border bg-gray-500"></div>
        <div className="flex flex-col items-end gap-[1.88rem]">
          {/* Name Field */}
          <div className="border-blue_gray-50 self-stretch rounded-[10px] border border-solid p-[1.25rem] shadow-sm">
            <p className="font-notosans text-gray-900_01 text-[1.00rem] font-normal leading-[1.00rem] tracking-[0.00rem]">
              <input
                type="text"
                className="text-gray-900_01 mb-6 w-full text-lg placeholder-black focus:placeholder-black focus:outline-none"
                placeholder={t("Name")}
                value={name}
                onChange={handleNameChange}
              />
            </p>
          </div>
          {/* Email Field */}
          <div className="border-blue_gray-50 self-stretch rounded-[10px] border border-solid p-[1.25rem] shadow-sm">
            <p className="font-notosans text-gray-900_01 text-[1.00rem] font-normal leading-[1.00rem] tracking-[0.00rem]">
              <input
                type="email"
                className="text-gray-900_01 mb-6 w-full text-lg placeholder-black focus:placeholder-black focus:outline-none"
                placeholder={t("Email")}
                value={email}
                onChange={handleEmailChange}
              />
            </p>
          </div>
          {/* Phone Field */}
          <div className="border-blue_gray-50 self-stretch rounded-[10px] border border-solid p-[1.25rem] shadow-sm">
            <p className="font-notosans text-gray-900_01 text-[1.00rem] font-normal leading-[1.00rem] tracking-[0.00rem]">
              <input
                type="tel"
                className="text-gray-900_01 mb-6 w-full text-lg placeholder-black focus:placeholder-black focus:outline-none"
                placeholder={t("Phone")}
                value={phone}
                onChange={handlePhoneChange}
              />
            </p>
          </div>
          {/* Title Field */}
          <div className="border-blue_gray-50 self-stretch rounded-[10px] border border-solid p-[1.25rem] pt-[0rem] shadow-sm">
            <p className="font-notosans text-gray-900_01 text-[1.00rem] font-normal leading-[1.00rem] tracking-[0.00rem]">
              <span className="text-gray-900_01 text-[1.50rem] font-semibold">
                <br />
              </span>
              <input
                type="text"
                className="text-gray-900_01 mb-6 w-full text-lg placeholder-black focus:placeholder-black focus:outline-none"
                placeholder={t("Enter your title")}
                maxLength={maxLength}
                onChange={handleChange}
                value={title}
              />
              <span className="text-[#5E6D77]">
                {title.length}/{maxLength}
              </span>
            </p>
          </div>

          <div className="!border-blue_gray-50 text-gray-900_01 self-stretch rounded-[10px] border border-solid p-[1.25rem] leading-[1.31rem] shadow-sm">
            <p className="font-notosans text-gray-900_01 text-[1.00rem] font-normal leading-[1.00rem] tracking-[0.00rem]">
              <textarea
                className="text-gray-900_01 h-[10.5rem] w-full text-base placeholder-black focus:placeholder-black focus:outline-none"
                name={t("Inquiry Textarea")}
                placeholder={t("Enter your inquiry")}
                maxLength={maxLengthI}
                onChange={handleChangeInquiry}
                value={titleI}
              ></textarea>
              <span className="text-[#5E6D77]">
                {titleI.length}/{maxLengthI}
              </span>
            </p>
          </div>

          <div className="border-blue_gray-50 flex gap-[0.625rem] self-stretch rounded-[10px] border border-solid p-[1.25rem] shadow-sm">
            {imageSrcs.length > 0 && (
              <div className="flex gap-[0.625rem] overflow-x-auto">
                {imageSrcs.map((src, index) => (
                  <div
                    key={index}
                    className="relative flex-shrink-0 items-center justify-center bg-gray-200"
                  >
                    <img
                      className="size-[5.5rem] object-cover"
                      src={src}
                      alt={`Uploaded ${index + 1}`}
                      loading="lazy"
                    />
                    <button
                      className="absolute right-[5px] top-[5px] flex h-6 w-6 items-center justify-center rounded-full border border-[#FFFFFF] bg-[#5E6D77] text-white"
                      onClick={() => handleImageRemove(index)}
                    >
                      <span className="text-sm">X</span>
                    </button>
                  </div>
                ))}
              </div>
            )}

            <img
              onClick={handleDivClick}
              className="size-[5.5rem] cursor-pointer"
              src={icAsset("../../assets/icons/InputImage.svg")}
              alt="Icon"
              loading="lazy"
            />
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
              accept="image/*"
              multiple
            />
          </div>
          <button
            disabled={!validateSubmit()}
            onClick={handleSubmit}
            className={`${
              validateSubmit() ? "bg-[#232323]" : "bg-gray-400"
            } flex h-[3.25rem] w-full cursor-pointer flex-row items-center justify-center whitespace-nowrap rounded-[50px] px-[2.13rem] text-center text-[1.00rem] text-white sm:w-auto sm:min-w-[7.00rem]`}
          >
            {t("Send")}
          </button>
          {isPopupVisible && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
              <div className="popup-modal w-[22.5rem] gap-[1.5rem] rounded-[1.25rem] bg-white p-[2rem]">
                <div className="text-center">
                  <div className="mb-1 flex justify-center">
                    <img
                      className="h-[3rem] w-[3rem] rounded-[0.5rem] object-cover"
                      src={icAsset("../../assets/icons/check.svg")}
                      alt="question icon"
                    />
                  </div>
                  <p className="mb-[1.5rem] text-lg">
                    {t("Your inquiry has been sent")}
                  </p>
                  <div className="text-center">
                    <button
                      className="font-noto-sans decoration-none w-[16.8125rem] rounded-[50px] border border-[#232323] bg-white py-[15px] text-center text-base font-semibold leading-5 text-[#232323] opacity-100 hover:bg-gray-100 focus:ring-2 focus:ring-gray-200"
                      onClick={closePopup}
                    >
                      {t("Check")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {isPopupSelectVisible && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
              <div className="popup-modal w-[30rem] gap-[1.5rem] rounded-[1.25rem] bg-white p-[2rem]">
                <div className="flex flex-col gap-4">
                  <div className="flex justify-between">
                    <h1 className="text-gray-900_01 undefined text-[1.13rem] font-semibold tracking-[0.00rem]">
                      {t("Please select a category")}
                    </h1>
                    <img
                      onClick={closePopupSelect}
                      className="h-[1.50rem] cursor-pointer"
                      src={icAsset("../../assets/icons/close.svg")}
                      alt="Close Button"
                      loading="lazy"
                    />
                  </div>
                  <div className="flex flex-wrap gap-[0.75rem]">
                    {categories.map((category, index) => (
                      <div
                        key={index}
                        onClick={() => toggleSelect(index)}
                        className={`flex h-[2.50rem] cursor-pointer flex-row items-center rounded-[20px] border border-solid border-gray-300 px-[1.25rem] text-[1.00rem] text-gray-900 hover:bg-blue-200 ${
                          category.select ? "bg-blue-200" : ""
                        } `}
                      >
                        <span>{category.label}</span>
                      </div>
                    ))}
                  </div>
                  <button
                    onClick={closePopupSelect}
                    className="flex h-[3.13rem] cursor-pointer flex-row items-center justify-center self-stretch whitespace-nowrap rounded-[24px] bg-gray-900 px-[2.13rem] text-center text-[1.00rem] font-semibold text-white"
                  >
                    {t("Ok")}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PostInquiry;
